exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notes[data-v-af11b0ca] {\n  width: 100%;\n  border: none;\n  resize: none;\n  padding-bottom: 2.25rem;\n}", ""]);

// exports
